<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('photo.menu2') }}</div>
                <div class="mainBody">
                    <div style=" width:100%; height:auto; margin:0 auto;">
                        <div class="title_tab">
                            <p :class="num == 1 ? 'active' : 'normal'" @click="numTab(1)"><img
                                        :src="num == 1 ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/video_w.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/video.png?v=0223'">{{
                                            $t('video') }}1</p>
                            <p :class="num == 2 ? 'active' : 'normal'" @click="numTab(2)"><img
                                        :src="num == 2 ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/video_w.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/video.png?v=0223'">{{
                                            $t('video') }}2</p>
                            <p :class="num == 3 ? 'active' : 'normal'" @click="numTab(3)"><img
                                        :src="num == 3 ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/video_w.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/video.png?v=0223'">{{
                                            $t('video') }}3</p>
                            <p :class="num == 4 ? 'active' : 'normal'" @click="numTab(4)"><img
                                        :src="num == 4 ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/video_w.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/video.png?v=0223'">{{
                                            $t('video') }}4</p>
                        </div>
                        <video v-if="num == 1" class="video" controls preload x5-video-player-type=" h5-page"
                            ref="video" x5-video-player-fullscreen="true" playsinline="true" webkit-playsinline=""
                            x5-video-orientation="portraint" x-webkit-airplay="allow"
                            src="https://oss.eventnet.cn/nissan2021/2024/video/1.mp4?v=1225"
                            :poster="'https://oss.eventnet.cn/nissan2021/2024/video/1.mp4?x-oss-process=video/snapshot,t_10000,m_fast,ar_auto'"></video>
                        <video v-if="num == 2" class="video" controls preload x5-video-player-type=" h5-page"
                            ref="video" x5-video-player-fullscreen="true" playsinline="true" webkit-playsinline=""
                            x5-video-orientation="portraint" x-webkit-airplay="allow"
                            src="https://oss.eventnet.cn/nissan2021/2024/video/2.mp4?v=1225"
                            :poster="'https://oss.eventnet.cn/nissan2021/2024/video/2.mp4?x-oss-process=video/snapshot,t_6000,m_fast,ar_auto'"></video>
                        <video v-if="num == 3" class="video" controls preload x5-video-player-type=" h5-page"
                            ref="video" x5-video-player-fullscreen="true" playsinline="true" webkit-playsinline=""
                            x5-video-orientation="portraint" x-webkit-airplay="allow"
                            src="https://oss.eventnet.cn/nissan2021/2024/video/3.mp4?v=1225"
                            :poster="'https://oss.eventnet.cn/nissan2021/2024/video/3.mp4?x-oss-process=video/snapshot,t_6000,m_fast,ar_auto'"></video>
                        <video v-if="num == 4" class="video" controls preload x5-video-player-type=" h5-page"
                            ref="video" x5-video-player-fullscreen="true" playsinline="true" webkit-playsinline=""
                            x5-video-orientation="portraint" x-webkit-airplay="allow"
                            src="https://oss.eventnet.cn/nissan2021/2024/video/4.mp4?v=1225"
                            :poster="'https://oss.eventnet.cn/nissan2021/2024/video/4.mp4?x-oss-process=video/snapshot,t_6000,m_fast,ar_auto'"></video>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path('photo')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            num: 1
        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/phone/videos']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        numTab(index) {
            this.num = index;
        },
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        }
    }
}
</script>
<style scoped>
.video {
    width: 100%;
}

.title_tab {
    font-size: .23rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .2rem;
}

.title_tab>p {
    width: 32%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: .6rem;
}

.title_tab img {
    width: auto;
    height: .22rem;
    margin-right: .05rem;
}

.active {
    background: #17aba2;
    color: #fff;
}

.normal {
    background: rgba(204, 204, 204, .5);
    color: #0b8383;
}
</style>


// WEBPACK FOOTER //
// src/views/photo/videos.vue